<template>
  <a-card class="style1">
    <a-input-search placeholder="Search by City & State" enter-button="Search" size="large" @search="onSearch" class="mb-4" />

    <a-table :loading="isLoading" :columns="columns" :data-source="locationList" size="middle" bordered rowKey="id">
      <div slot="action" slot-scope="record" class="action">
        <a href="javascript:;" @click="onEdit(record)">Edit</a>
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </div>
    </a-table>
    <a-modal v-model="isVisibleModal" title="Update location information" centered @ok="handleSubmit" :destroyOnClose="true" :closable="true" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Return</a-button>
        <a-button key="submit" type="primary" :loading="isLoading" @click="handleSubmit">Submit</a-button>
      </template>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input size="large" placeholder="Church name" v-decorator="['name', { rules: [{ required: true, message: 'Please input name!' }] }]" />
        </a-form-item>
        <a-form-item>
          <a-input size="large" placeholder="Address" v-decorator="['address', { rules: [{ required: true, message: 'Please input address!' }] }]" />
        </a-form-item>
        <a-form-item>
          <a-input size="large" placeholder="City" v-decorator="['city', { rules: [{ required: true, message: 'Please input city!' }] }]" />
        </a-form-item>
        <a-form-item>
          <a-input size="large" placeholder="State" v-decorator="['state', { rules: [{ required: true, message: 'Please input state!' }] }]" />
        </a-form-item>
        <a-form-item>
          <a-input size="large" placeholder="Country" v-decorator="['country', { rules: [{ required: true, message: 'Please input country!' }] }]" />
        </a-form-item>
        <a-form-item>
          <a-input size="large" placeholder="Zipcode" v-decorator="['zipcode', { rules: [{ required: true, message: 'Please input zipcode!' }] }]" />
        </a-form-item>
        <!-- <a-form-item>
          <a-input size="large" placeholder="Pastor" v-decorator="['pastor', { rules: [{ required: true, message: 'Please input pastor!' }] }]" />
        </a-form-item> -->
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import AdminService from '@/services/AdminService';
// import { slugData } from '@/utils';
export default {
  data() {
    return {
      locationList: [],
      form: this.$form.createForm(this),
      search: '',
      isLoading: true,
      isVisibleModal: false,
      locationEdit: {},
      columns: [
        { title: 'Email', dataIndex: 'pastor_email', key: 'pastor_email', width: 150 },
        { title: 'Church', dataIndex: 'name', key: 'name', width: 150 },
        { title: 'Address', dataIndex: 'address', key: 'address' },
        { title: 'City', dataIndex: 'city', key: 'city' },
        { title: 'State', dataIndex: 'state', key: 'state' },
        { title: 'Zipcode', dataIndex: 'zipcode', key: 'zipcode' },
        { title: 'Country', dataIndex: 'country', key: 'country' },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
      // .map(item => {
      //   if (item.key !== 'operation') {
      //     return {
      //       ...item,
      //       scopedSlots: {
      //         filterDropdown: 'filterDropdown',
      //         filterIcon: 'filterIcon',
      //         customRender: 'customRender',
      //       },
      //       onFilter: (value, record) => record[this.searchedColumn] && slugData(record[this.searchedColumn]).includes(slugData(value)),
      //       onFilterDropdownVisibleChange: visible => {
      //         if (visible) {
      //           setTimeout(() => {
      //             this.searchInput.focus();
      //           }, 0);
      //         }
      //       },
      //     };
      //   }
      //   return item;
      // }),
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitdata();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async doInitdata(query) {
      this.locationList = await await AdminService.location.get(query);
    },
    handleCancel() {
      this.locationEdit = {};
      this.isVisibleModal = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            await AdminService.location.update(this.locationEdit.id, values);
            await this.doInitdata(this.search);
            this.$notification['success']({
              message: 'Update successful.',
              description: `${values.name} was updated successfully.`,
            });
            this.isVisibleModal = false;
          } catch (error) {
            console.error({ error });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    onEdit(record) {
      this.locationEdit = record;
      this.isVisibleModal = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: record.name,
          address: record.address,
          city: record.city,
          state: record.state,
          country: record.country,
          zipcode: record.zipcode,
          pastor: record.pastor,
        });
      });
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.location.delete(record.id);
        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.name} was deleted successfully.`,
        });
        await this.doInitdata(this.search);
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },

    handleReset(clearFilters) {
      clearFilters();
    },
    async onSearch(value) {
      this.search = value;
      await this.doInitdata(this.search);
    },
  },
};
</script>
